import { Carousel, Row, Col } from "react-bootstrap";
import FinancingCard from "../VehicleCard/FinancingCard";
import "./FinancingCarousel.scss";

const SLIDES_PER_VIEW = 3;

const FinancingCarousel = ({ financiaciones }) => {
  if (!financiaciones || financiaciones.length === 0) return null;

  const groupedFinanciaciones = [];
  for (let i = 0; i < financiaciones.length; i += SLIDES_PER_VIEW) {
    groupedFinanciaciones.push(financiaciones.slice(i, i + SLIDES_PER_VIEW));
  }

  const hasMultipleSlides = groupedFinanciaciones.length > 1;
  const isSingleOption = financiaciones.length === 1;

  if (isSingleOption) {
    return (
      <div className="financing-carousel financing-carousel--single">
        <FinancingCard {...financiaciones[0]} />
      </div>
    );
  }

  return (
    <Carousel className="financing-carousel" controls={hasMultipleSlides} indicators={hasMultipleSlides}>
      {groupedFinanciaciones.map((group, idx) => (
        <Carousel.Item key={idx}>
          <Row>
            {group.map((f, i) => (
              <Col key={f.id || i} lg={4} md={6} xs={12} className="mb-4 d-flex">
                <FinancingCard {...f} />
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default FinancingCarousel;
